import axios from 'axios';
import { get } from 'lodash';

var api = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    withCredentials: true,
});

api.interceptors.request.use((config) => {
    let conf = {
        ...config,
        headers: {
            ...config.headers,
            'Content-Type': config.headers['Content-Type'] ? config.headers['Content-Type'] : 'application/json',
        }
    }

    //Add cache variable to all get requests
    if (config.method === "get") {
        conf.params = {
            ...get(conf, "params", {}),
            cache: process.env.REACT_APP_API_CACHE
        }
    }
    return conf;
})

api.interceptors.response.use(response => {
    return response;
}, (error) => {
    if (get(error, "response.status", false) === 401) {
        if (get(error, "config.url") !== "/account") {
            window.location.href = process.env.PUBLIC_URL || "/sign-in?redirect=" + window.location.pathname;
        }
    }
    return Promise.reject(error);
})

export default api;